import { filter, debounceTime } from 'rxjs/operators';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { ngHelper, CustomComponent, getLineBreakersQuantity, getLengthWithoutLineBreakers } from '@cakeiteasy/web-utils';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'cake-question-section',
  templateUrl: './cake-question-section.component.html'
})
export class CakeQuestionSectionComponent extends CustomComponent implements OnChanges, OnInit {
  @Input() public disabled: boolean;
  @Input() public helpText = '';

  @Input() public answer = '';

  @Input() public maxLength = 0;
  @Input() public question: string;

  @Input() public price: number;
  @Input() public currency = 'kr';

  @Output() public onChange: EventEmitter<any> = new EventEmitter();

  public textLength = 0;
  public answerChanged$ = new Subject<string>();

  ngOnInit() {
    this._subscribe();
  }

  private _subscribe() {
    this.addSubscriber(this.answerChanged$.pipe(
      filter((answer) => answer !== undefined),
      debounceTime(50))
      .subscribe((answer) => {
        this.textLength = getLengthWithoutLineBreakers(answer);
        const endPosition = this.maxLength + getLineBreakersQuantity(answer);
        this.answer = answer.substr(0, endPosition);
        this.onChange.emit(this.answer);
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'maxLength', (maxLength: any) => {
      if (this.answer && this.answer.length > maxLength) {
        const answer = this.answer.substr(0, maxLength);
        setTimeout(() => {
          this.onChange.emit(answer);
        });
      }
    });
  }
}

